import { ResponseError } from 'services/api/base';
import { useHandleRequestErrors } from 'utils/hooks';
import { useGetWBCultureDVOptionsQuery } from 'services/api/Meteorology/Agro/WBCulture/DetailedView';

export default function useOptions() {
  const { data, isLoading, error } = useGetWBCultureDVOptionsQuery();

  useHandleRequestErrors(error as ResponseError);

  return { options: data, isLoading };
}
